import BoxCta from './BoxCta';

export { type BoxCtaProps } from './BoxCta';
export default BoxCta;
